/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import React, {
  useState, useEffect, useRef, useCallback,
} from 'react';
import IcomoonReact from 'icomoon-react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment-timezone';
import Select from 'react-select';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import { TransitionGlobal } from '../../../../shared/GlobalStyles';
import StaticAddColumnDropdownComponent from './StaticAddColumnDropdownComponent';
import SwapPropDropdown from './SwapPropDropdown';
import TBportalTooltip from '../../../../shared/components/TBportalTooltip';
import Text from '../../../../shared/components/Text/Text';
import {
  updateProgrammedCalendarItem, updateReduxCalendarItem, updateReduxProgramItem, swapProgrammedItemOnChildCalendar, setCombineWithInfo,
  updateSavedWorkoutItem,
} from '../../ducks/calendarActions';
import capitalizeWords from '../../../../shared/utils/capitalizeWords';
import useSessionState from './hooks/useSessionState';
import { getDebouncedHandlerForTable, flushDebounceForTable } from './hooks/debounceHandler';
import { showErrorToast } from '../../../../shared/utils/toastManager';

const Wrapper = styled('div')`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

const WrapperRow = styled('div')`
  display: flex;
  width: 100%;
`;

const StaticDropdownWrapper = styled('div')`
  display: flex;
  margin-left: 16px;
  align-items: self-start;
  margin-top: 14px;
  flex-direction: column;
`;

const RemoveWrapper = styled('div')`
display: flex;
flex-direction: column;
height: 100%;
margin-bottom: 12px;
margin-top: 12px;
gap: 22px;

`;

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: scroll;
`;

const PrimaryRow = styled('div')`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

const ValueRow = styled('div')`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

const PrimaryRowValue = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Nunito Sans';
  width: 100%;
  margin-bottom: 3px;
`;

const RowValue = styled('input')`
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Nunito Sans';
  width: 100%;
  height: 32px;
  background: ${(props) => props.background};
  border: 1px solid #EEEEEE;
  text-align: center;
  border-radius: 4px;
  color: ${(props) => (props.textColor ? props.textColor : '#444444')};

  ::placeholder {
    color: ${(props) => (props.textColor ? props.textColor : '#444444')};
  }
`;

const SetRowValue = styled('input')`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Nunito Sans';
  width: 100%;
  height: 32px;
  background: #FCFCFC;
  border: 1px solid #EEEEEE;
  text-align: center;
  color: #BDBDBD;
  border-radius: 4px;
`;

const AddSetButtonContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const AddColumnButtonContainer = styled('div')`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const RemoveButtonContainer = styled('div')`
  display: flex;
  min-height: 34px;
`;

const AddSetIcon = styled('div')`
  padding: 4px;
  background: #444444;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const AddColumnIcon = styled('div')`
  padding: 4px;
  background: #444444;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const RemoveIcon = styled('div')`
  padding: 4px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
  cursor: pointer;
`;

const RowsContainer = styled('div')`
  height: 55px;
  display: flex;
  width: 100%;
  gap: 16px;
`;

const AddSetNumber = styled('input')`
  border-bottom: 1px solid #EEEEEE;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 30px;
  text-align: center;
  height: 16px;
`;

const RowValueContainer = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 160px;
`;

const SetRowValueContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 50px;
  max-width: 50px;
`;

const AddSetText = styled('div')`
  font-weight: 400;
  font-size: 16px;
  font-family: 'Nunito Sans';
  margin-left: 5px;
`;

const NameAndDropdown = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 3px;
`;

const PrimaryValueContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
  width: 100%;
  min-width: 160px;
`;

const SetPrimaryValueContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 16px;
  min-width: 50px;
  max-width: 50px;
`;

const TooltipDataContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 10px;
  padding-right: 16px;
  padding-left: 16px;
  gap: 10px;
  border-radius: 4px;
  max-width: 250px;
  min-width: 250px;
`;

const TooltipDataContainerAthleteInput = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 16px;
  padding-left: 16px;
  gap: 10px;
  border-radius: 4px;
  max-width: 250px;
`;

const UpdateInstanceSelectContainer = styled('div')`
  min-width: 215px;

  .react-select__indicator-separator {
    display: none;
  }

  .react-select__control {
    border: none;
    border-radius: 4px;
    min-height: 32px;
    box-shadow: none;
    background: transparent;
    cursor: pointer;
  }

  .react-select__single-value {
    color: #6B9FD9;
    font-family: 'Nunito Sans';
    font-size: 16px;
    font-weight: 400;
    margin: 0;
  }

  .react-select__option {
    font-family: 'Nunito Sans';
    font-size: 14px;
    color: #444444;
    font-weight: 400;
    cursor: pointer;
    padding: 16px;

    &--is-selected {
      background-color: transparent;
      color: #BDBDBD;
      font-weight: 400;
    }
  }
`;

const AddSetLeftContainer = styled('div')`
  display: flex;
  align-items: center;
`;

const CustomDropdownIndicator = ({ innerProps, selectProps }) => (
  <div
    {...innerProps}
    style={{
      padding: 0, marginLeft: -4, display: 'flex', alignItems: 'center',
    }}
  >
    <IcomoonReact
      iconSet={iconSet}
      size={12}
      icon='down-arrow'
      color='#6B9FD9'
      style={{
        transition: 'transform 0.2s ease',
        transform: selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
      }}
    />
  </div>
);

const updateInstanceOptions = [
  { value: 'single', label: 'Update only this instance', dropdownLabel: 'Update only this instance (Default)' },
  { value: 'all', label: 'Update all future instances', dropdownLabel: 'Update all future instances' },
];

const updateInstanceSelectStyles = {
  valueContainer: (provided) => ({
    ...provided,
    padding: '0',
    paddingRight: '4px',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    padding: '0',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '0',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? 'transparent' : (state.isFocused ? '#f9f9f9' : 'transparent'),
    color: state.isSelected ? '#BDBDBD' : '#444444',
    whiteSpace: 'nowrap',
    '&:active': {
      backgroundColor: '#f9f9f9',
    },
  }),
  menu: (provided) => ({
    ...provided,
    width: '300px',
    marginLeft: '-100px',
  }),
  menuList: (provided) => ({
    ...provided,
    width: '300px',
    boxShadow: '0 4px 8px 0 rgba(48, 49, 51, 0.10), 0 0 1px 0 rgba(48, 49, 51, 0.05)',
    borderColor: '#444444',
  }),
};

const TagTable = ({
  content,
  index,
  coachCompletion,
  completionOnly,
  isLeftAndRight,
  trackRepCount,
  trackVolumeLoad,
  forcePrUpdate,
  disablePrUpdate,
  swapDropdownSelectedExercise,
  nonSwappedItemFromParentCalendar,
  isRecurring,
  measure,
  date,
  dayNumber,
}) => {
  const dispatch = useDispatch();
  const targetRef = useRef(null);
  const targetRefRest = useRef(null);
  const targetRefVelocity = useRef(null);
  const targetRefPeakPower = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showTooltipPeakPower, setShowTooltipPeakPower] = useState(false);
  const [showTooltipVelocity, setShowTooltipVelocity] = useState(false);
  const [showTooltipRest, setShowTooltipRest] = useState(false);

  const programType = useSelector((state) => state.calendar.data.programType);
  const selectedProgramDayNumber = useSelector(
    (state) => state.calendar.data.selectedProgramDayNumber,
  );
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const calendarContainerScrollPositionTop = useSelector((state) => state.calendar.data.calendarContainerScrollPositionTop);
  const selectedDate = useSelector((state) => state.calendar.data.selectedDate);
  const effectiveDate = date || selectedDate;
  const endpointFormattedDate = moment(effectiveDate).format('YYYY-MM-DD');
  const combineWithInfo = useSelector((state) => state.calendar.data.combineWithInfo);

  const [numberForAdd, setNumberForAdd] = useState(1);

  const [primaryRows, setPrimaryRows] = useState([
    { name: 'set' },
    { name: content?.repType === 'time' ? 'time' : 'reps' },
    { name: 'load' },
    { name: 'rest', label: 'Rest (s)' },
    { name: 'tempo' },
    { name: 'velocity' },
    { name: 'peak power', label: 'Peak Power (w)' },
    { name: '%pr' },
  ]);

  const [tempo, setTempo] = useState(null);
  const [rest, setRest] = useState(null);
  const [velocity, setVelocity] = useState(content?.trackBarSpeed || false);
  const [peakPowerEnum, setPeakPowerEnum] = useState(content?.trackPeakPower);
  const [isBodyweight, setIsBodyweight] = useState(content?.repsOnly);
  const [isTime, setIsTime] = useState(content?.repType === 'time');

  const [firstPrimaryRowSwitchLoad, setFirstPrimaryRowSwitchLoad] = useState(true);
  const [firstContentLoad, setFirstContentLoad] = useState(true);
  const [firstLoadDropdownOptions, setFirstLoadDropdownOptions] = useState(true);

  /** we need to use session storage for primary row switch values so that if the user adds a field
   * it will not get wiped out between debounces if they haven't entered a value yet, changes to individual table properties
   *  will persist the session
   */
  const [primaryRowSwitch, setPrimaryRowSwitchState] = useSessionState(
    'primaryRowSwitchTagTable',
    content?.assignedId,
    {
      set: true,
      [content?.repType === 'time' ? 'time' : 'reps']: true,
      load: false,
      rest: !!content?.restTime || false,
      tempo: false,
      velocity,
      'peak power': content?.trackPeakPower || false,
    },
  );

  const keySwapDictionary = {
    load: 'prescribedValue',
    '%pr': 'percent',
    set: 'setNumber',
    reps: 'reps',
  };

  const [rows, setRows] = useState(content?.sets || []);
  const [selectedUpdateOption, setSelectedUpdateOption] = useState(updateInstanceOptions[0]);

  // Ref for the table container, used to scope keyboard shortcuts
  const tableContainerRef = useRef(null);

  const hasMounted = useRef(false);

  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true; /** skip first run because cell measurer wrapper will get that and we don't want to run it twice */
      return;
    }
    if (measure) {
      measure();
    }
  }, [rows]);

  const formatDate = () => `${moment(effectiveDate).format('YYYY-MM-DD')}`;

  /** debounced function will maintain values at the time of creation
       * on mount unless passed updated values, we can't to make sure we are
       * always using the most updated selected date and current user
       */
  const currentUserRef = useRef(currentUser);
  const selectedDateRef = useRef(effectiveDate);
  const dayNumberRef = useRef(dayNumber);
  useEffect(() => {
    currentUserRef.current = currentUser;
    selectedDateRef.current = effectiveDate;
    dayNumberRef.current = dayNumber;
  }, [currentUser, effectiveDate, dayNumber]);

  const formatUpdateOptionLabel = useCallback((option, { context }) => {
    if (context === 'menu') {
      return (
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%',
        }}
        >
          <span>{option.dropdownLabel || option.label}</span>
          {selectedUpdateOption.value === option.value && (
            <IcomoonReact iconSet={iconSet} size={12} icon='checkmark' color='#9E9E9E' />
          )}
        </div>
      );
    }
    return option.label;
  }, [selectedUpdateOption]);

  const debouncedHandleUpdateLiftItem = getDebouncedHandlerForTable(content.assignedId, (
    updatedRows,
    dbrest,
    dbtempo,
    dbPeakPower,
    dbVelocity,
    dbCompletionOnly,
    dbCoachCompletion,
    dbIsLeftAndRight,
    dbTrackRepCount,
    dbTrackVolumeLoad,
    dbIsBodyweight,
    dbIsTime,
    dbForcePrUpdate,
    dbDisablePrUpdate,
    dbContent,
    dbIndex,
    dbNonSwappedItemFromParentCalendar,
    reorder = false,
    updateOption = 'single',
  ) => {
    const updateItem = {
      assignedId: dbContent.assignedId,
      date: programType === 'free-form-program' ? '' : moment(effectiveDate).format('YYYY-MM-DD'),
      order: dbIndex,
      sets: updatedRows,
      groupingLetter: dbContent.groupingLetter,
      coachCompletion: dbCoachCompletion,
      completionOnly: dbCompletionOnly,
      eachSide: dbIsLeftAndRight,
      description: dbContent?.exercise?.description || '',
      type: 'tag',
      tagId: dbContent.tag.id,
      trackPeakPower: dbPeakPower,
      trackRepCount: dbTrackRepCount,
      trackVolumeLoad: dbTrackVolumeLoad,
      repsOnly: dbIsBodyweight,
      repType: dbIsTime ? 'time' : 'reps',
      forceMaxUpdate: dbForcePrUpdate,
      maxTrackingDisabled: dbDisablePrUpdate,
    };
    if (programType !== 'free-form-program') {
      if (!isRecurring) {
        updateItem.date = moment(selectedDateRef.current).format('YYYY-MM-DD');
      } else {
        updateItem.isRecurring = isRecurring;
      }
    }
    if (programType === 'free-form-program') {
      updateItem.dayNumber = dayNumberRef.current;
    }
    if (dbrest) {
      updateItem.restTime = dbrest;
    }
    if (dbtempo) {
      updateItem.tempo = dbtempo;
    }
    if (dbVelocity) {
      updateItem.trackBarSpeed = dbVelocity;
    }
    if (programType === 'free-form-program') {
      dispatch(updateSavedWorkoutItem(currentUserRef.current.accountCode, updateItem, dbIndex, dayNumberRef.current, reorder));
    }
    if (programType === 'calendar') {
      if (dbNonSwappedItemFromParentCalendar) {
        dispatch(swapProgrammedItemOnChildCalendar(currentUserRef.current.accountCode, updateItem, dbIndex, formatDate(selectedDateRef.current), reorder, updateOption));
      } else {
        dispatch(updateProgrammedCalendarItem(currentUserRef.current.accountCode, updateItem, dbIndex, formatDate(selectedDateRef.current), reorder, updateOption));
      }
    }
  });

  /** This useEffect listens for changes is the exercise chosen from the
     * table dropdown menu that can be used to change the exericse
     * it immediately updates the item in redux so we see the change in the table
     * immediately... we need to re create the object to pass to redux, then we call the debouce update the same way we do
     * for every other input change
     */
  useEffect(() => {
    if (swapDropdownSelectedExercise) {
      const updatedItem = {
        calendarId: content.calendarId,
        assignedId: content.assignedId,
        date: formatDate(effectiveDate),
        tagId: swapDropdownSelectedExercise.exerciseId,
        order: index,
        sets: rows,
        tag: swapDropdownSelectedExercise,
        title: swapDropdownSelectedExercise?.name,
        coachCompletion,
        completionOnly,
        eachSide: isLeftAndRight,
        type: 'tag',
        icon: 'tag',
        trackPeakPower: peakPowerEnum,
        trackRepCount,
        trackVolumeLoad,
        repsOnly: isBodyweight,
        repType: isTime ? 'time' : 'reps',
        forceMaxUpdate: forcePrUpdate,
        maxTrackingDisabled: disablePrUpdate,
      };
      if (rest) {
        updatedItem.restTime = rest;
      }
      if (tempo) {
        updatedItem.tempo = tempo;
      }
      if (velocity) {
        updatedItem.trackBarSpeed = velocity;
      }
      if (programType === 'free-form-program') {
        dispatch(updateReduxProgramItem(updatedItem, dayNumber || selectedProgramDayNumber, index));
      } else {
        dispatch(updateReduxCalendarItem(updatedItem, endpointFormattedDate, index));
      }
      debouncedHandleUpdateLiftItem.cancel();
      debouncedHandleUpdateLiftItem(
        rows,
        rest,
        tempo,
        peakPowerEnum,
        velocity,
        completionOnly,
        coachCompletion,
        isLeftAndRight,
        trackRepCount,
        trackVolumeLoad,
        isBodyweight,
        isTime,
        forcePrUpdate,
        disablePrUpdate,
        updatedItem,
        index,
        nonSwappedItemFromParentCalendar,
        false,
        selectedUpdateOption.value,
      );
      flushDebounceForTable(content.assignedId);
    }
  }, [swapDropdownSelectedExercise]);

  useEffect(() => {
    const isSource = combineWithInfo?.source?.length
      ? combineWithInfo.source.some((item) => item?.assignedId.toString() === content?.assignedId.toString())
      : false;

    const sourceItem = combineWithInfo?.source?.find(
      (item) => item?.assignedId.toString() === content?.assignedId.toString(),
    );

    const isTarget = combineWithInfo?.target?.assignedId === content?.assignedId;

    const targetItem = combineWithInfo?.target;

    if (combineWithInfo && ((isSource) || (isTarget))) {
      dispatch(setCombineWithInfo(null));
      const updatedItem = {
        ...content,
        date: formatDate(effectiveDate),
        order: index,
        sets: rows,
        groupingLetter: isSource
          ? sourceItem?.groupingLetter
          : isTarget
            ? targetItem?.groupingLetter
            : content?.groupingLetter,
        groupingColorCode: isSource
          ? sourceItem?.groupingColorCode
          : isTarget
            ? targetItem?.groupingColorCode
            : content?.groupingColorCode,
        coachCompletion,
        completionOnly,
        eachSide: isLeftAndRight,
        trackPeakPower: peakPowerEnum,
        trackRepCount,
        trackVolumeLoad,
        repsOnly: isBodyweight,
        repType: isTime ? 'time' : 'reps',
        forceMaxUpdate: forcePrUpdate,
        maxTrackingDisabled: disablePrUpdate,
      };
      if (rest) {
        updatedItem.restTime = rest;
      }
      if (tempo) {
        updatedItem.tempo = tempo;
      }
      if (velocity) {
        updatedItem.trackBarSpeed = velocity;
      }
      const reorder = true;
      debouncedHandleUpdateLiftItem(
        rows,
        rest,
        tempo,
        peakPowerEnum,
        velocity,
        completionOnly,
        coachCompletion,
        isLeftAndRight,
        trackRepCount,
        trackVolumeLoad,
        isBodyweight,
        isTime,
        forcePrUpdate,
        disablePrUpdate,
        updatedItem,
        index,
        nonSwappedItemFromParentCalendar,
        reorder,
        selectedUpdateOption.value,
      );
      flushDebounceForTable(content.assignedId);
    }
  }, [combineWithInfo]);

  /**
   * This is a useEffect that ensures that a. the various upper level dropdown options
   * being set to their default state doesn't trigger a put request, and b. subsequent
   * changes to the associated dropdown options DO trigger a put request
   */
  useEffect(() => {
    if (!firstLoadDropdownOptions) {
      debouncedHandleUpdateLiftItem(
        rows,
        rest,
        tempo,
        peakPowerEnum,
        velocity,
        completionOnly,
        coachCompletion,
        isLeftAndRight,
        trackRepCount,
        trackVolumeLoad,
        isBodyweight,
        isTime,
        forcePrUpdate,
        disablePrUpdate,
        content,
        index,
        nonSwappedItemFromParentCalendar,
        false,
        selectedUpdateOption.value,
      );
    } else {
      setFirstLoadDropdownOptions(false);
    }
  }, [
    coachCompletion,
    completionOnly,
    isLeftAndRight,
    trackRepCount,
    trackVolumeLoad,
    isBodyweight,
    isTime,
    peakPowerEnum,
    velocity,
    forcePrUpdate,
    disablePrUpdate,
  ]);

  /**
 * Updates the state of the primary row switch toggle and optionally modifies the rows array
 * based on the updated state. This function ensures that deactivated rows are removed
 * and the corresponding state for `tempo`, `rest`, `peak power`, and `velocity` is updated.
 * It also triggers the debounced update function to sync changes with the backend.
 *
 * Key features:
 * - Prevents unnecessary PUT requests on the initial load by managing a
 * `firstPrimaryRowSwitchLoad` flag.
 * - Deletes inactive fields from each row in the `rows`
 * array when their corresponding switch is toggled off.
 * - Updates `tempo`, `rest`, `peak power`, and `velocity` states as needed.
 * - Invokes a debounced backend update with the updated rows and state.
 */
  const setPrimaryRowSwitch = (newState) => {
    setPrimaryRowSwitchState(newState);
    if (!firstPrimaryRowSwitchLoad) {
      setFirstPrimaryRowSwitchLoad(false);
      const initializedRows = [...rows];
      const updatedRows = initializedRows.map((row) => {
        const cleanedRow = { ...row };
        Object.keys(newState).forEach((key) => {
          if (!newState[key]) {
            delete cleanedRow[keySwapDictionary[key]];
          }
        });
        return cleanedRow;
      });
      setRows(updatedRows);
      let newTempoValue;
      if (!newState.tempo) {
        setTempo(null);
        newTempoValue = null;
      } else {
        newTempoValue = tempo;
      }
      let newRestValue;
      if (!newState.rest) {
        setRest(null);
        newRestValue = null;
      } else {
        newRestValue = rest;
      }
      let bodyweightSetting;
      if (!newState.bodyweight) {
        setIsBodyweight(false);
        bodyweightSetting = false;
      } else {
        setIsBodyweight(true);
        bodyweightSetting = true;
      }
      let timeSetting;
      if (!newState.time) {
        setIsTime(false);
        timeSetting = true;
      } else {
        setIsTime(true);
        timeSetting = true;
      }
      let peakPowerEnumSetting;
      if (!newState['peak power']) {
        setPeakPowerEnum(0);
      } else {
        setPeakPowerEnum(1);
      }
      const updatedVelocity = newState.velocity;
      setVelocity(updatedVelocity);
      debouncedHandleUpdateLiftItem(
        updatedRows,
        newRestValue,
        newTempoValue,
        peakPowerEnumSetting,
        updatedVelocity,
        completionOnly,
        coachCompletion,
        isLeftAndRight,
        bodyweightSetting,
        timeSetting,
        forcePrUpdate,
        disablePrUpdate,
        content,
        index,
        nonSwappedItemFromParentCalendar,
        false,
        selectedUpdateOption.value,
      );
    }
    setFirstPrimaryRowSwitchLoad(false);
  };

  /**
 * Initializes the state of primary row switches and associated properties (tempo, rest, peak power)
 * based on the `content` (calendarItem) data when the component loads.
 * Specifically, it checks for `prescribedValue`,
 * `tempo`, `restTime`, and `trackPeakPower` in the `content` object and enables the corresponding
 * columns in the `primaryRowSwitch` state. Ensures this initialization logic only runs once
 * during the first load by checking the `firstContentLoad` flag.
 *
 * Dependencies:
 * - Runs whenever the `content` object changes.
 */
  useEffect(() => {
    if (content && content.sets) {
      setRows(content.sets);
      if (firstContentLoad) {
        const newPrimaryRowSwitch = { ...primaryRowSwitch };
        content?.sets.forEach((set) => {
          if (set.prescribedValue) {
            newPrimaryRowSwitch.load = true;
          }
          if (set.percent) {
            newPrimaryRowSwitch['%pr'] = true;
          }
        });
        if (content) {
          if (content.tempo) {
            newPrimaryRowSwitch.tempo = true;
            setTempo(content.tempo);
          }
          if (content.restTime) {
            newPrimaryRowSwitch.rest = true;
            setRest(content.restTime);
          }
          if (content.trackPeakPower) {
            newPrimaryRowSwitch['peak power'] = true;
            setPeakPowerEnum(content.trackPeakPower);
          }
          if (content.repsOnly) {
            newPrimaryRowSwitch.bodyweight = true;
            setIsBodyweight(true);
            setPrimaryRows(
              (prevRows2) => prevRows2.map(
                (row) => (row.name === 'load' ? { ...row, name: 'bodyweight' } : row),
              ),
            );
          }
          if (content.repType === 'time') {
            newPrimaryRowSwitch.time = true;
            setIsTime(true);
            setPrimaryRows(
              (prevRows2) => prevRows2.map(
                (row) => (row.name === 'reps' ? { ...row, name: 'time' } : row),
              ),
            );
          }
        }
        setPrimaryRowSwitch(newPrimaryRowSwitch);
        setFirstContentLoad(false);
      }
    }
  }, [content]);

  const updateColumnName = useCallback((oldName, newName) => {
    setPrimaryRows(
      (prevRows2) => prevRows2.map(
        (row) => (row.name === oldName ? { ...row, name: newName } : row),
      ),
    );

    setPrimaryRowSwitch((prevSwitch) => ({
      ...prevSwitch,
      [oldName]: false,
      [newName]: true,
    }));

    // Wipe out the `load` property in rows if switching from `load` to `bodyweight`
    if (oldName === 'load' && (newName === 'bodyweight')) {
      setRows((prevRows2) => prevRows2.map((row) => {
        const updatedRow = { ...row };
        delete updatedRow[keySwapDictionary.load]; // Remove the load property
        return updatedRow;
      }));
    }
  }, []);

  const addRow = () => {
    if (numberForAdd > 0) {
      const totalRowsAfterAdd = rows.length + numberForAdd;
      if (totalRowsAfterAdd < 11) {
        const lastRow = rows[rows.length - 1];
        const newRows = Array.from({ length: numberForAdd }, (_, i) => ({
          ...lastRow,
          setNumber: rows.length + i + 1,
        }));
        const updatedRows = [...rows, ...newRows];
        setRows(updatedRows);
        debouncedHandleUpdateLiftItem(
          updatedRows,
          rest,
          tempo,
          peakPowerEnum,
          velocity,
          completionOnly,
          coachCompletion,
          isLeftAndRight,
          trackRepCount,
          trackVolumeLoad,
          isBodyweight,
          isTime,
          forcePrUpdate,
          disablePrUpdate,
          content,
          index,
          nonSwappedItemFromParentCalendar,
          false,
          selectedUpdateOption.value,
        );
      } else {
        showErrorToast('The total number of sets cannot exceed 10.');
      }
    }
  };

  const removeRow = (removeIndex) => {
    const updatedRows = rows
      .filter((_, i) => i !== removeIndex) /** Remove the row at removeIndex */
      .map((row, mapIndex) => ({
        ...row,
        setNumber: mapIndex + 1, /** Update setNumber to maintain sequential order */
      }));

    setRows(updatedRows);

    debouncedHandleUpdateLiftItem(
      updatedRows,
      rest,
      tempo,
      peakPowerEnum,
      velocity,
      completionOnly,
      coachCompletion,
      isLeftAndRight,
      trackRepCount,
      trackVolumeLoad,
      isBodyweight,
      isTime,
      forcePrUpdate,
      disablePrUpdate,
      content,
      index,
      nonSwappedItemFromParentCalendar,
      false,
      selectedUpdateOption.value,
    );
  };

  const setTempoAndUpdate = (value) => {
    setTempo(value);
    debouncedHandleUpdateLiftItem(
      rows,
      rest,
      value,
      peakPowerEnum,
      velocity,
      completionOnly,
      coachCompletion,
      isLeftAndRight,
      trackRepCount,
      trackVolumeLoad,
      isBodyweight,
      isTime,
      forcePrUpdate,
      disablePrUpdate,
      content,
      index,
      nonSwappedItemFromParentCalendar,
      false,
      selectedUpdateOption.value,
    );
  };

  const setRestAndUpdate = (value) => {
    const intRest = parseInt(value, 10);
    setRest(intRest);
    debouncedHandleUpdateLiftItem(
      rows,
      intRest,
      tempo,
      peakPowerEnum,
      velocity,
      completionOnly,
      coachCompletion,
      isLeftAndRight,
      trackRepCount,
      trackVolumeLoad,
      isBodyweight,
      isTime,
      forcePrUpdate,
      disablePrUpdate,
      content,
      index,
      nonSwappedItemFromParentCalendar,
      false,
      selectedUpdateOption.value,
    );
  };

  const handleInputChange = (rowIndex, field, value) => {
    if (!value) {
      // eslint-disable-next-line no-param-reassign
      value = null;
    }
    setRows((prevRows2) => {
      const updatedRows = prevRows2.map((row, i) => (
        i === rowIndex ? { ...row, [keySwapDictionary[field]]: value } : row
      ));
      debouncedHandleUpdateLiftItem(
        updatedRows,
        rest,
        tempo,
        peakPowerEnum,
        velocity,
        completionOnly,
        coachCompletion,
        isLeftAndRight,
        trackRepCount,
        trackVolumeLoad,
        isBodyweight,
        isTime,
        forcePrUpdate,
        disablePrUpdate,
        content,
        index,
        nonSwappedItemFromParentCalendar,
        false,
        selectedUpdateOption.value,
      );
      return updatedRows;
    });
  };

  const columnInputResolver = (originalName, rowIndex, row) => {
    let name = originalName;
    if (name === 'time') {
      // eslint-disable-next-line no-param-reassign
      name = 'reps';
    }
    const fieldValue = row[keySwapDictionary[name]];
    if (name === 'tempo') {
      return (
        <RowValueContainer>
          <RowValue
            value={tempo}
            onChange={(e) => setTempoAndUpdate(e.target.value)}
            background='#FCFCFC'
          />
        </RowValueContainer>
      );
    }
    if (name === 'rest') {
      return (
        <RowValueContainer>
          <RowValue
            type='number'
            value={rest}
            onChange={(e) => setRestAndUpdate(e.target.value)}
            background='#FCFCFC'
          />
        </RowValueContainer>
      );
    }
    if (name === 'peak power') {
      if (peakPowerEnum === 1) {
        return (
          <RowValueContainer>
            <RowValue
              disabled
              placeholder='-'
              textColor='#BDBDBD'
              background='#FCFCFC'
            />
          </RowValueContainer>
        );
      }
      return (
        <RowValueContainer>
          <RowValue
            disabled
            placeholder='Left'
            textColor='#BDBDBD'
            style={{ marginRight: 8 }}
            background='#FCFCFC'
          />
          <RowValue
            disabled
            placeholder='Right'
            textColor='#BDBDBD'
            style={{ marginLeft: 8 }}
            background='#FCFCFC'
          />
        </RowValueContainer>
      );
    }
    return (
      <RowValueContainer>
        <RowValue
          type={originalName === 'time' ? 'number' : 'text'} // Change to "text" to allow non-numerical inputs
          aria-label={`${name} for set ${rowIndex + 1}`}
          value={name === 'bodyweight' ? '' : (fieldValue || null)} // Ensure fallback for undefined/null
          onChange={(e) => handleInputChange(rowIndex, name, e.target.value)}
          disabled={name === 'velocity' || name === 'bodyweight'}
          placeholder={name === 'velocity' || name === 'bodyweight' ? '-' : null}
          textColor={name === 'velocity' || name === 'bodyweight' ? '#BDBDBD' : '#444444'}
          background='#FCFCFC'
        />
      </RowValueContainer>
    );
  };

  return (
    <Wrapper ref={tableContainerRef}>
      <WrapperRow>
        <Container>
          <PrimaryRow>
            {primaryRows.map((primaryRow) => (
              primaryRowSwitch[primaryRow.name] ? (
                primaryRow.name === 'set' ? <SetPrimaryValueContainer>{capitalizeWords(primaryRow.name)}</SetPrimaryValueContainer> : (
                  <PrimaryValueContainer>
                    <PrimaryRowValue>
                      {primaryRow.name === 'reps' || primaryRow.name === 'time' || primaryRow.name === 'velocity' || primaryRow.name === 'peak power' ? (
                        <NameAndDropdown
                          ref={
                      primaryRow.name === 'reps'
                        ? targetRef
                        : primaryRow.name === 'peak power'
                          ? targetRefPeakPower
                          : primaryRow.name === 'velocity'
                            ? targetRefVelocity
                            : null
                    }
                        >
                          {(primaryRow.name === 'peak power' || primaryRow.name === 'reps' || primaryRow.name === 'velocity') && (
                          <IcomoonReact
                            iconSet={iconSet}
                            size={14}
                            icon='info2'
                            color='rgba(189, 189, 189, 1)'
                            style={{ cursor: 'pointer' }}
                            onMouseEnter={() => {
                              if (primaryRow.name === 'reps') {
                                setShowTooltip(true);
                              }
                              if (primaryRow.name === 'peak power') {
                                setShowTooltipPeakPower(true);
                              }
                              if (primaryRow.name === 'velocity') {
                                setShowTooltipVelocity(true);
                              }
                            }}
                            onMouseLeave={() => {
                              if (primaryRow.name === 'reps') {
                                setShowTooltip(false);
                              }
                              if (primaryRow.name === 'peak power') {
                                setShowTooltipPeakPower(false);
                              }
                              if (primaryRow.name === 'velocity') {
                                setShowTooltipVelocity(false);
                              }
                            }}
                          />
                          )}
                          {showTooltip && primaryRow.name === 'reps' && (
                          <TBportalTooltip targetRef={targetRef} backgroundColor='rgba(68, 68, 68, 1)' setShowToolTip={setShowTooltip} scrollContainerRefTopPosition={calendarContainerScrollPositionTop}>
                            <TooltipDataContainer>
                              <Text fontSize='13px' fontWeight={400} color='white'>Accepted Inputs</Text>
                              <ul style={{ paddingLeft: '20px' }}>
                                <li>
                                  <Text fontSize='13px' fontWeight={400} color='white'>Absolute (e.g. 5)</Text>
                                </li>
                                <li><Text fontSize='13px' fontWeight={400} color='white'>Range (e.g. 8-12)</Text></li>
                                <li><Text fontSize='13px' fontWeight={400} color='white'>Minimum (e.g. 8+)</Text></li>
                                <li><Text fontSize='13px' fontWeight={400} color='white'>“AMAP” for as many as possible</Text></li>
                              </ul>
                            </TooltipDataContainer>
                          </TBportalTooltip>
                          )}
                          {primaryRow.name === 'peak power' && showTooltipPeakPower && (
                          <TBportalTooltip targetRef={targetRefPeakPower} backgroundColor='rgba(68, 68, 68, 1)' setShowToolTip={setShowTooltipPeakPower} scrollContainerRefTopPosition={calendarContainerScrollPositionTop}>
                            <TooltipDataContainerAthleteInput>
                              <Text fontSize='13px' fontWeight={400} color='white'>Athlete input only</Text>
                            </TooltipDataContainerAthleteInput>
                          </TBportalTooltip>
                          )}
                          {primaryRow.name === 'velocity' && showTooltipVelocity && (
                          <TBportalTooltip targetRef={targetRefVelocity} backgroundColor='rgba(68, 68, 68, 1)' setShowToolTip={setShowTooltipVelocity} scrollContainerRefTopPosition={calendarContainerScrollPositionTop}>
                            <TooltipDataContainerAthleteInput>
                              <Text fontSize='13px' fontWeight={400} color='white'>Athlete input only</Text>
                            </TooltipDataContainerAthleteInput>
                          </TBportalTooltip>
                          )}
                          <SwapPropDropdown
                            setPrimaryRowSwitch={setPrimaryRowSwitch}
                            primaryRowSwitch={primaryRowSwitch}
                            rowName={primaryRow.name}
                            size={12}
                            updateColumnName={updateColumnName}
                            setPeakPowerEnum={setPeakPowerEnum}
                            peakPowerEnum={peakPowerEnum}
                            name={primaryRow.name === 'load' ? capitalizeWords('Load') : primaryRow.label || capitalizeWords(primaryRow.name)}
                            unit={null}
                            setIsBodyweight={setIsBodyweight}
                            setIsTime={setIsTime}
                          />
                        </NameAndDropdown>
                      ) : (
                        <NameAndDropdown
                          ref={
                           primaryRow.name === 'rest' ? targetRefRest : null
                          }
                        >
                          {(primaryRow.name === 'rest') && (
                          <IcomoonReact
                            iconSet={iconSet}
                            size={14}
                            icon='info2'
                            color='rgba(189, 189, 189, 1)'
                            style={{ cursor: 'pointer' }}
                            onMouseEnter={() => {
                              if (primaryRow.name === 'rest') {
                                setShowTooltipRest(true);
                              }
                            }}
                            onMouseLeave={() => {
                              if (primaryRow.name === 'rest') {
                                setShowTooltipRest(false);
                              }
                            }}
                          />
                          )}
                          {primaryRow.name === 'rest' && showTooltipRest && (
                          <TBportalTooltip targetRef={targetRefRest} backgroundColor='rgba(68, 68, 68, 1)' setShowToolTip={setShowTooltipRest} scrollContainerRefTopPosition={calendarContainerScrollPositionTop}>
                            <TooltipDataContainerAthleteInput>
                              <Text fontSize='13px' fontWeight={400} color='white'>Rest value will be the same for all sets.</Text>
                            </TooltipDataContainerAthleteInput>
                          </TBportalTooltip>
                          )}
                          <SwapPropDropdown
                            setPrimaryRowSwitch={setPrimaryRowSwitch}
                            primaryRowSwitch={primaryRowSwitch}
                            rowName={primaryRow.name}
                            size={12}
                            updateColumnName={updateColumnName}
                            setPeakPowerEnum={setPeakPowerEnum}
                            peakPowerEnum={peakPowerEnum}
                            name={primaryRow.name === 'load' ? capitalizeWords('Load') : primaryRow.label || capitalizeWords(primaryRow.name)}
                            unit={null}
                            setIsBodyweight={setIsBodyweight}
                            setIsTime={setIsTime}
                          />
                        </NameAndDropdown>
                      )}
                    </PrimaryRowValue>
                  </PrimaryValueContainer>
                )
              ) : null
            ))}
          </PrimaryRow>
          {rows.map((row, rowIndex) => (
            <ValueRow key={rowIndex}>
              <RowsContainer>
                {primaryRows.map((primaryRow) => (
                  primaryRowSwitch[primaryRow.name] ? (
                    primaryRow.name === 'set' ? (
                      <SetRowValueContainer>
                        <SetRowValue
                          type='number'
                          aria-label={`${primaryRow.name} for set ${rowIndex + 1}`}
                          value={rowIndex + 1}
                          disabled
                          onChange={(e) => handleInputChange(rowIndex, primaryRow.name, e.target.value)}
                        />
                      </SetRowValueContainer>
                    )
                      : columnInputResolver(primaryRow.name, rowIndex, row)
                  ) : null
                ))}
              </RowsContainer>
            </ValueRow>
          ))}
        </Container>
        <StaticDropdownWrapper>
          <StaticAddColumnDropdownComponent
            primaryRows={primaryRows}
            setPrimaryRows={setPrimaryRows}
            primaryRowSwitch={primaryRowSwitch}
            setPrimaryRowSwitch={setPrimaryRowSwitch}
            setPrimaryRowSwitchState={setPrimaryRowSwitchState}
            size={12}
            containerRef={tableContainerRef}
          >
            <AddColumnButtonContainer className='add-column-button'>
              <AddColumnIcon>
                <IcomoonReact
                  iconSet={iconSet}
                  size={12}
                  icon='plus'
                  color='white'
                />
              </AddColumnIcon>
            </AddColumnButtonContainer>
          </StaticAddColumnDropdownComponent>
          <RemoveWrapper>
            {rows.map((row, rowIndex) => (
              <>
                {rows.length !== 1 ? (
                  <RemoveButtonContainer onClick={() => removeRow(rowIndex)}>
                    <RemoveIcon>
                      <IcomoonReact
                        iconSet={iconSet}
                        size={12}
                        icon='remove'
                        color='#9E9E9E'
                      />
                    </RemoveIcon>
                  </RemoveButtonContainer>
                ) : <div style={{ display: 'flex', minWidth: 20, minHeight: 34 }} />}
              </>
            ))}
          </RemoveWrapper>
        </StaticDropdownWrapper>
      </WrapperRow>
      {rows?.length < 10 && (
      <AddSetButtonContainer>
        <AddSetLeftContainer>
          <AddSetIcon onClick={addRow}>
            <IcomoonReact
              iconSet={iconSet}
              size={12}
              icon='plus'
              color='white'
            />
          </AddSetIcon>
          <AddSetText>
            Add
            {' '}
            <AddSetNumber
              value={numberForAdd}
              onChange={(e) => {
                const inputValue = parseInt(e.target.value, 10);
                setNumberForAdd(inputValue);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  addRow();
                }
              }}
              type='number'
            />
            {' '}
            {numberForAdd > 1 ? 'Sets' : 'Set'}
          </AddSetText>
        </AddSetLeftContainer>
        {/* <UpdateInstanceSelectContainer>
          <Select
            options={updateInstanceOptions}
            value={selectedUpdateOption}
            onChange={(option) => setSelectedUpdateOption(option)}
            className='react-select'
            classNamePrefix='react-select'
            isSearchable={false}
            formatOptionLabel={formatUpdateOptionLabel}
            menuPortalTarget={document.body}
            menuPosition='fixed'
            styles={updateInstanceSelectStyles}
            components={{ DropdownIndicator: CustomDropdownIndicator }}
          />
        </UpdateInstanceSelectContainer> */}
      </AddSetButtonContainer>
      )}
    </Wrapper>
  );
};

TagTable.propTypes = {
  content: PropTypes.instanceOf(Object).isRequired,
  swapDropdownSelectedExercise: PropTypes.instanceOf(Object).isRequired,
  index: PropTypes.number.isRequired,
  coachCompletion: PropTypes.bool.isRequired,
  completionOnly: PropTypes.bool.isRequired,
  isLeftAndRight: PropTypes.bool.isRequired,
  trackRepCount: PropTypes.bool.isRequired,
  trackVolumeLoad: PropTypes.bool.isRequired,
  forcePrUpdate: PropTypes.bool.isRequired,
  disablePrUpdate: PropTypes.bool.isRequired,
  nonSwappedItemFromParentCalendar: PropTypes.bool.isRequired,
  isRecurring: PropTypes.string,
  measure: PropTypes.func.isRequired,
  date: PropTypes.string,
  dayNumber: PropTypes.string,
};

TagTable.defaultProps = {
  isRecurring: null,
  date: null,
  dayNumber: null,
};

export default TagTable;
